import { PureComponent } from 'react';

import { Link, RouterLinkProps as LinkProps } from 'src/router/components';
import { settings } from 'src/settings';

export type RelativeLinkProps = Omit<LinkProps, 'to'> & {
  to: string;
  qaId?: string;
  'data-testid'?: string;
};

// eslint-disable-next-line import/no-default-export
export default class RelativeLink extends PureComponent<RelativeLinkProps> {
  render() {
    const { to, children, className, qaId, ...rest } = this.props;
    return (
      <Link
        className={className}
        data-qa={qaId}
        to={to.replace(settings().CANON_URL, '')}
        {...rest}
      >
        {children}
      </Link>
    );
  }
}
